<template>
  <div>
    <va-modal
      :value="isOpen"
      id="createScheduledNotificationModal"
      ref="createScheduledNotificationModal"
      size="medium"
      :showOkay="true"
      :okText="$t('modals.buttons.save')"
      :cancelText="$t('modal.close')"
      @cancel="onClickCancel"
      @ok="handleCreateOrUpdate"
    >
      <div class="evollu-form">
        <div class="row">
          <h4>
            {{ $t(`people_manager.patient.scheduled_notifications.create_new`)}}
          </h4>
        </div>
      </div>
    </va-modal>
  </div>

</template>

<script>
export default {
  data: function() {
    return {
      isOpen: false
    }
  },
  mounted() {
    this.isOpen = true
  },
  methods: {
    onClickCancel: function () {
      this.$emit('cancel')
      setTimeout(() => {
        this.isOpen = false
      }, 500)
    },
    handleCreateOrUpdate: function() {

    }
  }
};
</script>

<style scoped lang="scss">

</style>
